/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-sys-text-muted-color);
  --font-weight: var(--nve-ref-font-weight-regular);
  --font-size: var(--nve-ref-font-size-100);
  --gap: var(--nve-ref-space-xs);
  --_icon-color: var(--color);
}

[internal-host] {
  --icon-color: var(--color);
  gap: var(--gap);
  color: var(--color);
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  display: flex;
}

nve-icon {
  --color: var(--_icon-color);
}

:host([status='success']) {
  --color: var(--nve-sys-support-success-emphasis-color);
}

:host([status='warning']) {
  --color: var(--nve-sys-support-warning-emphasis-color);
}

:host([status='error']),
:host([error]) {
  --color: var(--nve-sys-support-danger-emphasis-color);
}

:host([status='muted']) {
  --color: var(--nve-sys-text-muted-color);
}
